const START_DATE = process.env.SPRING_PROMO_START
  ? new Date(process.env.SPRING_PROMO_START)
  : new Date('2025-05-19T01:00:00-08:00');

const END_DATE = process.env.SPRING_PROMO_END
  ? new Date(process.env.SPRING_PROMO_END)
  : new Date('2025-05-31T23:59:59-08:00');

export const springPromoDateRange = {
  startDate: START_DATE,
  endDate: END_DATE,
};
